<template>
  <div class="plan-add-menu p-2 text-left text-sm mt-8">
    <ul>
      <li>
        <a v-on:click="$emit('newPlaceFromMap')">
          <img src="@/assets/images/icon-menu-map.svg" :alt="$t('map_label')" />
          <span class="ml-1">{{ $t('add_destination_from_map') }}</span>
        </a>
      </li>
      <li>
        <a v-on:click="$emit('newPlace')">
          <img src="@/assets/images/icon-menu-category.svg" :alt="$t('genre_label')" />
          <span class="ml-1">{{ $t('add_destination_from_category') }}</span>
        </a>
      </li>
      <li v-if="favorites.length > 0">
        <a v-on:click="$emit('newPlaceFromFavorites')">
          <img src="@/assets/images/icon-menu-favorite.svg" :alt="$t('genre_label')" />
          <span class="ml-1">{{ $t('add_destination_from_favorite') }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      favorites: 'favorites/getFavoritedPlaces'
    })
  }
}
</script>
